import React from "react"
import AlertBar from "../components/alertBar"
import Layout from "../components/shared/layout-en"
import ContactSection from "../components/shared/contact-section"
import SEO from "../components/seo"
import ModalFormContact from "../components/modal-form-contact"
import Text from "../text.json"
import HandShake from "../images/handshake.jpg"
import "../components/styles/contact.scss"

const ContactEmployer = () => {
  const [modalShow, setModalShow] = React.useState(false)
  let pageDescription = "Reach over 2 million qualified candidates with minimal burden on your human resources team."
  return (
    <>
      <AlertBar french={false} />
      <Layout french={false}>
        <SEO title="Employer Services" description={pageDescription} lang="en" />
        <section className="contact__section">
          <ContactSection
            heading={Text.en.employer["section-1__heading"]}
            text={Text.en.employer["section-1__text"]}
            buttonText={Text.en.employer["section-1__button"]}
            setModalShow={setModalShow}
          />
          <ContactSection
            heading={Text.en.employer["section-2__heading"]}
            text={Text.en.employer["section-2__text"]}
            buttonText={Text.en.employer["section-2__button"]}
            image={HandShake}
            styleClass={"contact__jumbo--white"}
            setModalShow={setModalShow}
          />
          <ContactSection
            heading={Text.en.employer["section-3__heading"]}
            text={Text.en.employer["section-3__text"]}
            buttonText={Text.en.employer["section-3__button"]}
            styleClass={"contact__jumbo--orange"}
            setModalShow={setModalShow}
          />
          <ContactSection
            heading={Text.en.employer["section-4__heading"]}
            text={Text.en.employer["section-4__text"]}
            buttonText={Text.en.employer["section-4__button"]}
            styleClass={"contact__jumbo--white"}
            setModalShow={setModalShow}
          />
          <ModalFormContact
            french={false}
            formTitle={"Contact Form"}
            show={modalShow}
            onHide={() => setModalShow(false)}
          />
        </section>
      </Layout>
    </>
  )
}
export default ContactEmployer
